import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncatetext',
  standalone: true
})
export class TruncatetextPipe implements PipeTransform {

  transform(value: string | null | undefined, length: number = 30): string {
    if (!value) return '';
    if (length <= 0) return ''; 
    if (value.length <= length) return value; 

    const ellipsis = '...';
    let truncatedText = value.slice(0, length).trim();

    const lastSpace = truncatedText.lastIndexOf(' ');
    if (lastSpace > 0) {
      truncatedText = truncatedText.slice(0, lastSpace);
    }

    truncatedText = truncatedText.replace(/[!,.?;:]+$/, '');

    return truncatedText + ellipsis;
  }

}
